export default value => {
  if (value) {
    const hours = Math.floor(value / 3600)
    const minutes = Math.floor((value - hours * 3600) / 60).toString().padStart(2, '0')
    return `${hours}:${minutes}`
  }
}
